import Product from '@/shared/types/product.type';
import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type UpdateProductVariantsProps<T> = {
  productId: string;
  body: T[];
  onUnauthorized?: () => void;
};

const updateProductVariants = async <T>({
  productId,
  body,
  onUnauthorized,
}: UpdateProductVariantsProps<T>): Promise<
  (Response<Product['variants']> | Response<T>)[]
> => {
  const token = getCookie('auth_token');
  const chunks = chunkArray(body, 5);

  const responses: (Response<Product['variants']> | Response<T>)[] = [];

  for (const chunk of chunks) {
    const promises = chunk.map((variant: T) => {
      return fetcher<Response<Product['variants']>>({
        url: `/products/${productId}/variants/${(variant as { variant_id: string }).variant_id}/`,
        method: 'PUT',
        token,
        body: variant,
        onUnauthorized,
      }).catch((error) => {
        console.error(
          'Error occurred in function "updateProductVariants" in file "src/shared/api/product/updateProductVariants.ts":',
          error,
        );
        return {
          ...error,
          data: variant,
        } as Response<T>;
      });
    });

    const results = await Promise.all(promises);
    responses.push(...results);
  }

  return responses;
};

export default updateProductVariants;
